import { render, staticRenderFns } from "./WarehouseLoader.vue?vue&type=template&id=74a08538"
import script from "./WarehouseLoader.vue?vue&type=script&lang=js"
export * from "./WarehouseLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports